import React, { useState } from 'react'
import AddNewImplantableDevices from './AddNewImplantableDevices';

const ImplantableDevices = ({ data, expandAll, setIsRecordSaved, ...props }) => {
  let { isViewAllowed, IsEditAllowed , IsDeleteAllowed} = props;
  let activeCheckList = [true, "true", "True", "Active"];
  let inActiveCheckList = [false, "false", "False", "InActive", "In Active"];
  const [isOpenImplantableDevices, setIsOpenImplantableDevices] = useState(false);
  const [implantableDevicesID, setImplantableDevicesID] = useState();
  const [showActiveProblems, setShowActiveProblems] = useState(true);

  let ActiveInActiveExists = data.filter(it => [...activeCheckList, ...inActiveCheckList].includes(it.ImplantableDeviceStatus))?.length > 0;
  let currentViewItems = data.filter(item => (showActiveProblems ? activeCheckList : [...activeCheckList, ...inActiveCheckList]).includes(item.ImplantableDeviceStatus));

  const [expandItems, setExpandItems] = useState(true);

  const handleToggleExpand = () => {
    setExpandItems(prev => !prev);
  }
  const AddImplantableDevices = (ID) => {
    if(!isViewAllowed) return;
    setImplantableDevicesID(ID)
    setIsOpenImplantableDevices(prev => !prev);
  }
  const CloseImplantableDevices = () => {
    setIsOpenImplantableDevices(false)
  }


  const ShowHideInActive = () => {
    let currentViewItems = data.filter(item => (inActiveCheckList).includes(item.ImplantableDeviceStatus));

    return currentViewItems.length > 0 ?
      <p className='heading validate-color cursor-pointer px-2 pt-2' onClick={() => setShowActiveProblems(prev => !prev)}>
        {showActiveProblems ? `Show InActive(${currentViewItems.length})` : `Hide InActive(${currentViewItems.length})`}
      </p> : null
  }
  let PopupScreen = "";
  if (isOpenImplantableDevices) {
    PopupScreen = <AddNewImplantableDevices isOpenImplantableDevices={isOpenImplantableDevices} implantableDevicesID={implantableDevicesID} setIsRecordSaved={setIsRecordSaved} setImplantableDevicesID={setImplantableDevicesID} onClose={CloseImplantableDevices} patientID={props?.patientID} // onDeleteImplantableDevices={DeleteImplantableDevices} 
    IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}
    />
  }
  return (
    <>
      {PopupScreen}
      {/* <div className='content-box '>
        <div className='d-flex align-items-center justify-content-between br-bottom-1 ar-light pb-2 mb-2'>
            <p className='heading fs-13'>Implantable Devices</p>
            <i className='icon-dash-plus fs-19' onClick={()=>AddImplantableDevices(null)}></i>
        </div>
        {expandAll && 
        <>
          <div className='mb-2'>
              <p className='text validate-color '>Stents</p>
          </div>
          <p className='heading validate-color'>Show Historical(1)</p>
        </>}
        
        {expandAll &&
        (data.length > 0 ?
        data.map(item => (
          <p className='text validate-color' onClick={() => AddImplantableDevices(item.PAtientGoalID)}>{item.Goal}</p>)  
        ) :
        <>
        <div className="d-flex gap-6 align-items-center">
          <div className="custom_check_box text-center d-flex">
            <input
              type="checkbox"
              className="form-check-input mt-0"
              name='IsAutoEligiblity'
              id='IsAutoEligiblity'
              checked={false}
            />
          </div>
          <p className='text'>Patient has no active problems</p>
        </div>
        </>)}
    </div> */}
      <div className='content-box px-0'>
        <div className='d-flex align-items-center justify-content-between br-bottom-1 ar-light pb-1 mb-1 mx-2'>
          <p className='cursor-pointer fs-13 heading user-select-none' onClick={handleToggleExpand}>Implantable Devices</p>
          <i className={`icon-dash-plus fs-19 ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddImplantableDevices(null)}></i>
        </div>
        <div className="">
          {expandItems &&
            expandAll &&
            (ActiveInActiveExists ?
              <>
                <div className='d-flex flex-column gap-1 problem-scroll px-2'>
                  {currentViewItems.map(item => {
                    let active = activeCheckList.includes(item.ImplantableDeviceStatus);

                    if ((showActiveProblems && !active)) return;
                    return (
                      <div className=''>
                        <div className='d-flex align-items-center justify-content-between'>
                          <p className={`text validate-color cursor-pointer font-m mb-1 validation_message ${isViewAllowed ? '' : 'disable'}`}  onClick={() => AddImplantableDevices(item.PatientImplantableDeviceID)}>{item.DeviceName}</p>
                          {["In Active", "False"].includes(item.ImplantableDeviceStatus) &&
                            <p className='text Partialdenied-clr fst-italic text-nowrap'>InActive</p>}
                        </div>
                        {/* <p className='px-1 text bg_light validation_message text-nowrap my-1'>{item.DeviceName}</p> */}
                        <div className="d-flex justify-content-between align-items-center">
                          <div className='d-flex align-items-center gap-1'>
                            <p className='text font-m'>Implantation Date:</p>
                            <p className='text'>{item.OnSetDate}</p>
                          </div>
                          {/* <p className='heading'>{item.Acuity}</p> */}
                        </div>
                      </div>
                    )
                  })}
                </div>
                <ShowHideInActive />
              </> :
              <>
                {/* <div className="d-flex gap-6 align-items-center">
                <div className="custom_check_box text-center d-flex">
                  <input
                    type="checkbox"
                    className="form-check-input mt-0"
                    name='IsAutoEligiblity'
                    id='IsAutoEligiblity'
                    checked={false}
                  />
                </div>
                <p className='text'>Patient has no implantable devices</p>
              </div> */}
              </>
            )}
        </div>
      </div>
    </>
  )
}

export default ImplantableDevices